import { UiAlertBanner } from '@experiences/ui-common';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import type { ILicenseAndKey } from '../../../common/interfaces/licenses';
import {
    fetchAccountLicenseWithMlKeysAndUpdateAccountType,
    licenseManagementAccountUrl,
} from '../../../services/licensing/management/AccountService';
import {
    isAdminSelector,
    isUnlicensedSelector,
} from '../../../store/selectors';

const UiLicenseReactivationNeededBanner: React.FC = () => {
    const { formatMessage: translate } = useIntl();
    const isAdmin = useSelector(isAdminSelector);

    const isUnlicensedMode = useSelector(isUnlicensedSelector);

    const {
        data, isValidating,
    } = useSWR<ILicenseAndKey, Error>(
        isAdmin && !isUnlicensedMode ? licenseManagementAccountUrl : null,
        fetchAccountLicenseWithMlKeysAndUpdateAccountType,
    );

    const isReactivationNeeded = useMemo(
        () => !isValidating && data && data.accountLicense.needsLicenseReactivation,
        [ data, isValidating ]
    );

    return (
        <>
            {isReactivationNeeded && (
                <UiAlertBanner
                    type="warning"
                    closeable={false}
                    data-cy="ui-license-reactivation-needed-banner">
                    {translate({ id: 'CLIENT_LICENSE_REACTIVATION_NEEDED_WARNING_BANNER' })}
                </UiAlertBanner>
            )}
        </>
    );
};
export default UiLicenseReactivationNeededBanner;
